import { Chat, ChatMessage } from "../../models/Chat";
import { slavtCommunicationHTTP } from "../http";

export function getChatWithTeacher(chatId: string) {
  return slavtCommunicationHTTP
    .get<Chat>(`/chat-homeworks/${chatId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getChatWithStudents(chatId: string) {
  return slavtCommunicationHTTP
    .get<Chat>(`/chat-exams/${chatId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function postMessageOnTeacherChat(chatId: string, message: string) {
  return slavtCommunicationHTTP
    .post<ChatMessage>(`/chat-homeworks/${chatId}/messages`, { text: message })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function postMessageOnStudentsChat(chatId: string, message: string) {
  return slavtCommunicationHTTP
    .post<ChatMessage>(`/chat-exams/${chatId}/messages`, { text: message })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}
